import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TombOfAkhenatenGameAssets} from "../TombOfAkhenatenGameAssets";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TOASlideShowPage} from "./TOASlideShowPage";

export class TOAGameIntroConfig implements GameIntroViewConfig {
    public static INTRO_BG = TombOfAkhenatenGameAssets.INTRO_BACKGROUND;
    public static INTRO_LOGO = TombOfAkhenatenGameAssets.INTRO_LOGO;
    public static INTRO_FEATURE_1 = TombOfAkhenatenGameAssets.INTRO_FEATURE_1;
    public static INTRO_FEATURE_2 = TombOfAkhenatenGameAssets.INTRO_FEATURE_2;
    public static INTRO_FEATURE_3 = TombOfAkhenatenGameAssets.INTRO_FEATURE_3;
    public static INTRO_DIVIDER = TombOfAkhenatenGameAssets.INTRO_DIVIDER;

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.4,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };

    stampConfig: StampConfig = {
        xWays: false,
        xNudge: false,
        volatility: Volatility.HIGH
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: TOASlideShowPage[];

    private stickSpins: TOASlideShowPage;
    private freeSpins: TOASlideShowPage;
    private winWays: TOASlideShowPage;

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader: ImgLoader = new ImgLoader(NolimitApplication.resourcePath);

        imgLoader.add(TOAGameIntroConfig.INTRO_BG, TOAGameIntroConfig.INTRO_BG);
        imgLoader.add(TOAGameIntroConfig.INTRO_LOGO, TOAGameIntroConfig.INTRO_LOGO);
        imgLoader.add(TOAGameIntroConfig.INTRO_FEATURE_1, TOAGameIntroConfig.INTRO_FEATURE_1);
        imgLoader.add(TOAGameIntroConfig.INTRO_FEATURE_2, TOAGameIntroConfig.INTRO_FEATURE_2);
        imgLoader.add(TOAGameIntroConfig.INTRO_FEATURE_3, TOAGameIntroConfig.INTRO_FEATURE_3);
        imgLoader.add(TOAGameIntroConfig.INTRO_DIVIDER, TOAGameIntroConfig.INTRO_DIVIDER);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_BG));
        bgSprite.anchor.set(0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_DIVIDER));
        topSprite.anchor.set(0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_DIVIDER));
        bottomSprite.anchor.set(0.5);
        bottomSprite.scale.y *= -1;
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_LOGO));
        logoSprite.anchor.set(0.5);
        this.logo.addChild(logoSprite);

        this.createPages();
    }

    private createPages(): void {
        this.stickSpins = new TOASlideShowPage(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_FEATURE_1), Translation.translate("win more than 20000x bet"));
        this.freeSpins = new TOASlideShowPage(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_FEATURE_2), Translation.translate("win more than 20000x bet"));
        this.winWays = new TOASlideShowPage(ImgLoader.getImgTexture(TOAGameIntroConfig.INTRO_FEATURE_3), Translation.translate("win more than 20000x bet"));

        this.pages = [this.stickSpins, this.winWays, this.freeSpins];
    }
}
